import { render } from "./ConfirmInitialHoldModal.vue?vue&type=template&id=c512626c&scoped=true&ts=true&lang=pug"
import script from "./ConfirmInitialHoldModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmInitialHoldModal.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmInitialHoldModal.vue?vue&type=style&index=0&id=c512626c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c512626c"]])

export default __exports__